import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

export const LOCAL_AUTH_TOKEN_PATH = '/api/local-auth/token';

/**
 * Fetches a dev-only JWT from ESA-API's LocalAuthController (which only responds when the API
 * runs with ASPNETCORE_ENVIRONMENT=Local) for the user configured in environment.localUserEmail.
 * Only used when environment.useMockAuth is true - see LocalAuthInterceptor.
 */
@Injectable({ providedIn: 'root' })
export class LocalAuthService {
  private tokenPromise: Promise<string> | null = null;

  constructor(private http: HttpClient) {}

  getToken(): Promise<string> {
    if (!this.tokenPromise) {
      this.tokenPromise = firstValueFrom(
        this.http.post<{ value: string }>(`${environment.apiUrl}${LOCAL_AUTH_TOKEN_PATH}`, {
          email: environment.localUserEmail
        })
      ).then(response => response.value);
    }
    return this.tokenPromise;
  }
}
